import { Container } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import LibraryCards from '@/components/library/LibraryCards';
import LibraryHeader from '@/components/library/LibraryHeader';

const librarySearchSchema = z.object({
  type: z.enum(['actions', 'indicators']).default('actions'),
  filter: z.string().catch(''),
  sort: z.string().catch(''),
  search: z.string().catch(''),
});

export const Route = createFileRoute('/_layout/$slug/library')({
  component: Library,
  validateSearch: (search) => librarySearchSchema.parse(search),
});

function Library() {
  return (
    <Container maxW="full" maxH="100vh" overflow={'hidden'} p={0}>
      <LibraryHeader />
      <LibraryCards />
    </Container>
  );
}
